import { telemetryService } from '@locus-taxy/encore-observability/telemetry';
import { initObservabilityClient } from '@locus-taxy/encore-observability/observability';
import {
  GROUNDCOVER_INGESTION_KEY,
  GROUNDCOVER_RUM_DSN,
  GROUNDCOVER_RUM_INGESTION_KEY,
  OTLP_ENDPOINT,
  STACK,
  getApiBaseUrl,
} from '../config';
import { getClientIdFromUrl } from '../hooks/useClientId';

export enum O11yEventName {
  AppInitialized = 'app_initialized',
  UserLoggedOut = 'user_logged_out',
  // Record-access dimension scope (DP-3188 — PRD §9). Namespaced because the
  // three read as one funnel; emitters live in `dimensionScopeO11y.ts`.
  DimensionScopePickerShown = 'dimension_scope.picker_shown',
  DimensionScopePickerCommitted = 'dimension_scope.picker_committed',
  DimensionScopeSidebarCommitted = 'dimension_scope.sidebar_committed',
}

const APP_IDENTIFIER = 'encore-dashboard';

export function initBrowserO11yInternal() {
  // Initialize telemetry service - OTel
  // Get the proper base URL using clientId from URL (prod structure), fallback to generic 'client' URL
  // This is just for initialization and tracking purposes
  try {
    const clientId = getClientIdFromUrl();
    const baseUrl = clientId
      ? getApiBaseUrl(clientId)
      : getApiBaseUrl('client');
    const baseUrls = baseUrl ? [baseUrl] : [];

    // DP-4750: the exporter's environment tag, endpoint and key come from
    // /config.json, not from VITE_* variables baked into the bundle.
    telemetryService.init(APP_IDENTIFIER, __APP_VERSION__, baseUrls, {
      environment: STACK,
      otlpEndpoint: OTLP_ENDPOINT,
      apiKey: GROUNDCOVER_INGESTION_KEY,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      '[encore-o11y] Failed to initialize browser telemetry:',
      error instanceof Error ? error.message : error
    );
    // Skip/disable telemetry on error - continue without telemetry initialization
  }

  // Initialize groundcover
  const observabilityClient = initObservabilityClient({
    apiKey: GROUNDCOVER_RUM_INGESTION_KEY,
    dsn: GROUNDCOVER_RUM_DSN,
    // Cluster does not matter for RUM, but is required by the library, here we use a placeholder
    cluster: 'frontend-web',
    // Custom application identifier set by user
    appId: APP_IDENTIFIER,
    // DP-4750: tag RUM sessions with the stack from /config.json
    environment: STACK,
  });

  if (observabilityClient) {
    observabilityClient.trackEvent({
      name: O11yEventName.AppInitialized,
      attributes: {
        version: __APP_VERSION__,
      },
    });
  }
}

export function initBrowserO11y() {
  const disableBrowserO11y = import.meta.env.DEV;

  if (disableBrowserO11y) {
    return;
  }

  initBrowserO11yInternal();
}
